export class Profile {
  displayName: string;
  email: string;
  bio: string;
  photoUrl: string;
}
